module.exports = __webpack_public_path__ + "static/media/map-animation-pause-hover.2b527d4b.svg";